/* unplugin-vue-components disabled */import script from "./SiliconflowList.vue?vue&type=script&setup=true&lang=js"
export * from "./SiliconflowList.vue?vue&type=script&setup=true&lang=js"

import "./SiliconflowList.vue?vue&type=style&index=0&id=0789fce5&lang=css"

const __exports__ = script;

export default __exports__